<template lang="pug">
#intro
  alert-popup(:q="5")
  normal-intro(
    v-if="productCategorySelectStyle == '1'",
    :productDetail="productDetail"
  )
  business-intro(
    v-if="productCategorySelectStyle == '2'",
    :productDetail="productDetail"
  )
</template>

<script>
import NormalIntro from "@/components/product/Intro/NormalIntro";
import BusinessIntro from "@/components/product/Intro/BusinessIntro";
import AlertPopup from "@/components/common/AlertPopup";

export default {
  name: "ProductIntro",
  props: {
    productDetail: Object,
    productCategorySelectStyle: String,
  },
  components: {
    "normal-intro": NormalIntro,
    "business-intro": BusinessIntro,
    AlertPopup,
  },
  data() {
    return {
    };
  },
};
</script>
